interface Image {
  className?: string;
  src?: string;
  alt?: string;
  height?: number;
  width?: number;
  id?: string;
  /** Override the fallback image shown when src is missing or broken */
  fallback?: string;
}

const INSTITUTION_FALLBACK = '/assets/img/institution-placeholder.png';

const BackendImage = (props: Image) => {
  const { src, fallback = INSTITUTION_FALLBACK, ...rest } = props;

  // If no src provided, render placeholder directly (no base URL prefix needed)
  if (!src) {
    return (
      <img
        className={rest.className}
        src={fallback}
        height={rest.height ?? 300}
        alt={rest.alt}
        width={rest.width ?? 300}
        id={rest.id}
      />
    );
  }

  // Combine the base path and the provided src to create the full image source URL
  const fullSrc = `${process.env.REACT_APP_API_BASE_URL}${src}`;

  return (
    <img
      className={rest.className}
      src={fullSrc}
      height={rest.height ?? 300}
      alt={rest.alt}
      width={rest.width ?? 300}
      id={rest.id}
      onError={(e) => {
        const target = e.currentTarget;
        target.onerror = null; // prevent infinite loop
        target.src = fallback;
      }}
    />
  );
};

export default BackendImage;
